import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Content } from "antd/lib/layout/layout";
import { Row, Col, Image, Divider, Menu, Affix } from "antd";
import * as img from "./img/index";
import BacktoTop, { backtoTopFunction } from "./components/BacktoTop";
import { toast } from "react-toastify";

const ProjectListPage = () => {
  const [isBooth, setbooth] = useState(true);
  const [isCounter, setcounter] = useState(false);
  const [isResidential, setresidential] = useState(false);
  const [isCommercial, setcommercial] = useState(false);
  const [isInfo, setinfo] = useState(false);

  backtoTopFunction();

  const ProjectType = (type) => {
    backtoTopFunction();
    setbooth(false);
    setcounter(false);
    setcommercial(false);
    setresidential(false);
    setinfo(false);
    switch (type) {
      case "booth":
        setbooth(true);
        break;
      case "counter":
        setcounter(true);
        break;
      case "commercial":
        setcommercial(true);
        break;
      case "residential":
        setresidential(true);
        break;
      case "info":
        setinfo(true);
        break;
      default:
        return null;
    }
  };

  return (
    <div>
      <Affix offsetTop={64}>
        <motion.div
          transition={{ ease: "easeIn", duration: 0.3 }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: [0, 1], x: [-100, 0] }}
          exit={
            window.innerWidth > 450
              ? { opacity: [1, 0], x: [0, 100] }
              : { opacity: [1, 0] }
          }
        >
          <Menu
            mode="horizontal"
            // style={{ padding: "0 10vw 0" }}
            className="navMenu"
            defaultActiveFirst="booth"
          >
            <Menu.Item key="booth" onClick={() => ProjectType("booth")}>
              Booth fair
            </Menu.Item>
            <Menu.Item
              key="commercial"
              onClick={() => ProjectType("commercial")}
            >
              Commercial
            </Menu.Item>
            <Menu.Item key="counter" onClick={() => ProjectType("counter")}>
              Counter
            </Menu.Item>
            <Menu.Item
              key="residential"
              onClick={() => ProjectType("residential")}
            >
              Residential
            </Menu.Item>
            <Menu.Item key="info" onClick={() => ProjectType("info")}>
              IngDesign's Info
            </Menu.Item>
          </Menu>
        </motion.div>
      </Affix>

      <AnimatePresence exitBeforeEnter={true}>
        {isCommercial ? (
          <motion.div
            transition={{ ease: "easeIn", duration: 0.4 }}
            initial={{ opacity: 0 }}
            whileInView={
              window.innerWidth > 450
                ? { opacity: [0, 1], x: [-100, 0] }
                : { opacity: [0, 1] }
            }
            exit={
              window.innerWidth > 450
                ? { opacity: [1, 0], x: [0, 100] }
                : { opacity: [1, 0] }
            }
          >
            <Content className="site-layout">
              <div className="center-img-grid">
                {/* <div className={window.innerWidth > 450 ? "center-img-grid" : ""}> */}
                <h1>Commercial Design</h1>
                <hr />

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>MNC Design </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[18, 24]}>
                    <Image.PreviewGroup>
                      {img.mnc.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div
                            whileHover={{ scale: 0.95 }}
                            whileTap={{ scale: 0.95, zIndex: 1 }}
                          >
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}

                              // onClick={() => {
                              //   navi("/project/" + index.link + "/details");
                              // }}
                            />

                            <h2>
                              <strong>{index.title}</strong>
                            </h2>
                          </motion.div>
                        </Col>

                        // </div>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Other Commercial Design </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[18, 24]}>
                    <Image.PreviewGroup>
                      {img.listCommercial.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div
                            whileHover={{ scale: 0.95 }}
                            whileTap={{ scale: 0.95, zIndex: 1 }}
                          >
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}

                              // onClick={() => {
                              //   navi("/project/" + index.link + "/details");
                              // }}
                            />

                            <h2>
                              <strong>{index.title}</strong>
                            </h2>
                          </motion.div>
                        </Col>

                        // </div>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>
              </div>
            </Content>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>

      <AnimatePresence exitBeforeEnter={true}>
        {isBooth ? (
          <motion.div
            transition={{ ease: "easeIn", duration: 0.4 }}
            initial={{ opacity: 0 }}
            whileInView={
              window.innerWidth > 450
                ? { opacity: [0, 1], x: [-100, 0] }
                : { opacity: [0, 1] }
            }
            exit={
              window.innerWidth > 450
                ? { opacity: [1, 0], x: [0, 100] }
                : { opacity: [1, 0] }
            }
          >
            <Content className="site-layout">
              <div className="center-img-grid">
                {/* <div className={window.innerWidth > 450 ? "center-img-grid" : ""}> */}
                <h1>Booth Design</h1>
                <hr />
                {/* <h1>Template Style : 3-grid-style-album</h1> */}
                <Row gutter={[18, 24]}>
                  <Image.PreviewGroup>
                    {img.listBooth.map((index, i) => (
                      // <div key={i} className="">
                      <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                        <motion.div
                          whileHover={{ scale: 0.95 }}
                          whileTap={{ scale: 0.95, zIndex: 1 }}
                        >
                          <Image
                            src={index.img}
                            className="imgproject"
                            alt={index.title}

                            // onClick={() => {
                            //   navi("/project/" + index.link + "/details");
                            // }}
                          />

                          <h2>
                            <strong>{index.title}</strong>
                          </h2>
                        </motion.div>
                      </Col>

                      // </div>
                    ))}
                  </Image.PreviewGroup>
                </Row>
              </div>
            </Content>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>

      <AnimatePresence exitBeforeEnter={true}>
        {isCounter ? (
          <motion.div
            initial={{ opacity: 0 }}
            transition={{ ease: "easeIn", duration: 0.4 }}
            whileInView={
              window.innerWidth > 450
                ? { opacity: [0, 1], x: [-100, 0] }
                : { opacity: [0, 1] }
            }
            exit={
              window.innerWidth > 450
                ? { opacity: [1, 0], x: [0, 100] }
                : { opacity: [1, 0] }
            }
          >
            <Content className="site-layout">
              <div className="center-img-grid">
                {/* <div className={window.innerWidth > 450 ? "center-img-grid" : ""}> */}
                <h1>Counter Design</h1>
                <hr />

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : Aeon Tj Barat </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.aeontjbarat.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : Easy Rent </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.easyrent.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : Living World </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.livingworld.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : PRJ Jakarta Fair </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.PRJjakartafair.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                            <h2>
                              <strong>{index.title}</strong>
                            </h2>
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : SIAL Interfood </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.sialinterfood.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                            <h2>
                              <strong>{index.title}</strong>
                            </h2>
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Advance : Showroom </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.showroom.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Bunny Belle Gramedia CP </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.bbelle.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>Other event / fair Counter Design</strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.listfair.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>

                <div style={{ padding: "2vh 0 3vh" }}>
                  <Divider orientation="left">
                    <h2>
                      <strong>We Coffee </strong>
                    </h2>
                  </Divider>
                  <Row gutter={[8, 16]}>
                    <Image.PreviewGroup>
                      {img.wecoffee.map((index, i) => (
                        // <div key={i} className="">
                        <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                          <motion.div whileHover={{ scale: 0.95 }}>
                            <Image
                              src={index.img}
                              className="imgproject"
                              alt={index.title}
                            />
                          </motion.div>
                        </Col>
                      ))}
                    </Image.PreviewGroup>
                  </Row>
                </div>
              </div>
            </Content>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>

      {isResidential ? (
        <AnimatePresence>
          <motion.div
            transition={{ ease: "easeIn", duration: 0.4 }}
            initial={{ opacity: 0 }}
            whileInView={
              window.innerWidth > 450
                ? { opacity: [0, 1], x: [-100, 0] }
                : { opacity: [0, 1] }
            }
            exit={
              window.innerWidth > 450
                ? { opacity: [1, 0], x: [0, 100] }
                : { opacity: [1, 0] }
            }
          >
            <Content className="site-layout">
              <div className="center-img-grid">
                {/* <div className={window.innerWidth > 450 ? "center-img-grid" : ""}> */}
                <h1>Residential Design</h1>
                <hr />
                {/* <h1>Template Style : 3-grid-style-album</h1> */}
                <Row gutter={[18, 24]}>
                  <Image.PreviewGroup>
                    {img.listResidential.map((index, i) => (
                      // <div key={i} className="">
                      <Col span={window.innerWidth > 450 ? 8 : 24} key={i}>
                        <motion.div
                          whileHover={{ scale: 0.95 }}
                          whileTap={{ scale: 0.95, zIndex: 1 }}
                        >
                          <Image
                            src={index.img}
                            className="imgproject"
                            alt={index.title}
                          />

                          <h2>
                            <strong>{index.title}</strong>
                          </h2>
                        </motion.div>
                      </Col>

                      // </div>
                    ))}
                  </Image.PreviewGroup>
                </Row>
                <hr />
              </div>
            </Content>
          </motion.div>
        </AnimatePresence>
      ) : (
        ""
      )}

      <AnimatePresence exitBeforeEnter={true}>
        {isInfo ? (
          <motion.div
            transition={{ ease: "easeIn", duration: 0.4 }}
            initial={{ opacity: 0 }}
            whileInView={
              window.innerWidth > 450
                ? { opacity: [0, 1], x: [-100, 0] }
                : { opacity: [0, 1] }
            }
            exit={
              window.innerWidth > 450
                ? { opacity: [1, 0], x: [0, 100] }
                : { opacity: [1, 0] }
            }
          >
            <Content className="site-layout">
              <div className="center-img-grid">
                {/* <div className={window.innerWidth > 450 ? "center-img-grid" : ""}> */}
                <h1>IngDesign's Info </h1>
                <hr />
                {/* <h1>Template Style : 3-grid-style-album</h1> */}
                <h2>
                  I'm currently very busy with work right now, but I'll keep
                  update my portofolio
                </h2>
                <h2>
                  If you're interested in my work, you can contact me here :{" "}
                </h2>
                <p
                  style={{ color: "rgba(15, 43, 222, 0.8)" }}
                  onClick={() => {
                    navigator.clipboard.writeText("inggriany.only@gmail.com");
                    toast.success("Email Copied!", {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                    });
                  }}
                >
                  <b>inggriany.only@gmail.com</b>
                </p>
              </div>
            </Content>
          </motion.div>
        ) : (
          ""
        )}
      </AnimatePresence>

      <BacktoTop />
    </div>
  );
};

export default ProjectListPage;
